// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"6966c88a","704":"dc79e3cc"}[chunkId] + ".chunk.js";
};